<template>
  <div>
    <div v-if="cookieConsented && !loading">
      <masonry ref="mason" class="social-posts-grid" :cols="{default: 4, 1000: 3, 700: 2, 450: 1}" :gutter="30">
        <div class="item" v-for="(item, index) in this.posts" :key="index" v-html="item.embedded"></div>
      </masonry>
    </div>
    <div v-if="!cookieConsented && !loading">
      <onetrust-blocker></onetrust-blocker>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  name: 'social-posts-grid',
  props: {
    posts: {
      type: Array
    }
  },
  data() {
    return {
      cookieConsented: false,
      loading: true
    }
  },
  watch: {
    date() {
      this.loading = false
    },
    marketing() {
      this.loading = false
      if (this.marketing) {
        this.cookieConsented = true
        const instagram = document.createElement('script')
        instagram.setAttribute('src', '//www.instagram.com/embed.js')
        this.$el.appendChild(instagram)
        const twitter = document.createElement('script')
        twitter.setAttribute('src', '//platform.twitter.com/widgets.js')
        this.$el.appendChild(twitter)
      } else {
        this.cookieConsented = false
      }
    }
  },
  computed: {
    ...mapGetters('onetrust', [
      'marketing',
      'date'
    ])
  },
  methods: {
    onResize() {
      this.swiper.virtual.update()
    }
  }
}
</script>

